import React from 'react';
import { Redirect } from "react-router-dom";

import Auth from '../services/Auth';
import { fire } from '../fire';

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false
        }
    }

    componentWillMount() {
        if (!Auth.isAuth())
            return;
        fire.auth().signOut()
            .then(() => {
                Auth.logout();
                this.setState({ redirect: true });
            })
    }

    render() {
        return (
            <div>
                {!this.state.redirect && "Is loging out..."}
                {this.state.redirect && <Redirect to='/' />}
            </div>
        )
    }
}

export default Logout;
